
import makerjs from "makerjs";
function B29(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    B = Param[0].param,L = Param[1].param,R = Param[2].param, T = Param[3].param, S1 = Param[4].param, S2 = Param[5].param, 
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       b = B * 1 * myZoom,
       l = L * 1 * myZoom,
       t = T * 1 * myZoom,
       r = R * 1 * myZoom,
       s1 = S1 * 1 * myZoom,
       s2 = S2 * 1 * myZoom,
        // r = R * 1 * myZoom,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       
       x0 = 0, x1 = 0, x2 =b-s1-t ,x3 =b-s1 ,x4 =b ,x5 =b , 
       y0 = 0, y1 =l,y2 =r, y3 =r,y4 =s2,y5 =0,glassH =r, glassW = b,h=r,w=b;

   if (b !== 0) {
       var TxtB ="B="+ B;
   }  if (l !== 0) {
    var TxtL = "L="+L;
  }    if (t !== 0) {
    var TxtT = "T="+T;
  }     if (r !== 0) {
    var TxtR = "R="+R;
  }     if (s1 !== 0) {
    var TxtS1 = "S1="+S1;
  }     if (s2 !== 0) {
    var TxtS2 = "S2="+S2;
  } 




  var drawAbnormalShapeB29 = {
    paths: {
     "LeftLine1": new makerjs.paths.Line([x0, y0], [x1, y1]),
     "LeftLine2": new makerjs.paths.Line([x1, y1], [x2,y2]),
     "TopLine":new makerjs.paths.Line([x2,y2], [x3,y3]), 
     "RightLine1":new makerjs.paths.Line([x3,y3], [x4,y4]), 
     "RightLine2":new makerjs.paths.Line([x4,y4], [x5,y5]),
     "BottomLine": new makerjs.paths.Line([x5,y5], [x0, y0]),
    }
};
var drawAbnormalShapeB29MarkR = {
    paths: {
     "RightLine": new makerjs.paths.Line([x5+ 2*markShift, y5], [x5+ 2*markShift, y3]),
     "RightShortUpline": new makerjs.paths.Line([x5, y3], [x5+ 4 * markShift, y3]),
     "RightShortDnline": new makerjs.paths.Line([x5, y5], [x5+ 4 * markShift, y5]),
    }
};
var drawAbnormalShapeB29MarkS2 = {
    paths: {
     "RightLine": new makerjs.paths.Line([x4+ markShift, y4], [x5+ markShift, y5]),
     "RightShortUpline": new makerjs.paths.Line([x4, y4], [x4+ 2 * markShift, y4]),
     "RightShortDnline": new makerjs.paths.Line([x5, y5], [x5+ 2 * markShift, y5]),
    }
};
var drawAbnormalShapeB29MarkB = {
    paths: {
     "BottomLine": new makerjs.paths.Line([x0, y0- markShift], [x5, y5- markShift]),
     "BotmShortLfline": new makerjs.paths.Line([x0, y0], [x0, y0 - 2 * markShift]),
     "BotmShortRTline": new makerjs.paths.Line([x5, y5], [x5, y5 - 2 * markShift]),
    }

};
var drawAbnormalShapeB29MarkT = {
    paths: {
     "BottomLine": new makerjs.paths.Line([x2, y2+ markShift], [x3, y3+ markShift]),
     "BotmShortLfline": new makerjs.paths.Line([x2, y2], [x2, y2 + 2 * markShift]),
     "BotmShortRTline": new makerjs.paths.Line([x3, y3], [x3, y3 + 2 * markShift]),
    }

};
var drawAbnormalShapeB29MarkS1 = {
    paths: {
     "BottomLine": new makerjs.paths.Line([x3, y3+ markShift], [x4, y3+ markShift]),
     "BotmShortLfline": new makerjs.paths.Line([x3, y3], [x3, y3 + 2 * markShift]),
     "BotmShortRTline": new makerjs.paths.Line([x4, y3], [x4, y3 + 2 * markShift]),
    }

};
var drawAbnormalShapeB29MarkL = {
    paths: {
     "RightLine": new makerjs.paths.Line([x0- markShift, y0], [x1- markShift, y1]),
     "RightShortUpline": new makerjs.paths.Line([x0, y0], [x0- 2 * markShift, y0]),
     "RightShortDnline": new makerjs.paths.Line([x1, y1], [x1- 2 * markShift, y1]),
    }
};
makerjs.model.addCaption(drawAbnormalShapeB29MarkB, TxtB, [x0, y0 - 2 * markShift], [x5, y5 - 2 * markShift]);//长度文字
makerjs.model.addCaption(drawAbnormalShapeB29MarkT, TxtT, [x2, y2+ 2*markShift], [x3, y3+ 2*markShift]);//长度文字
makerjs.model.addCaption(drawAbnormalShapeB29MarkR, TxtR, [x5+5*markShift, y5], [x5+5*markShift, y3]);//宽度文字
makerjs.model.addCaption(drawAbnormalShapeB29MarkS2, TxtS2, [x5+ 4*markShift, y5], [x4+ 4*markShift, y4]);//宽度文字
makerjs.model.addCaption(drawAbnormalShapeB29MarkL, TxtL, [x0-2*markShift, y0], [x1-2*markShift, y1]);//宽度文字
makerjs.model.addCaption(drawAbnormalShapeB29MarkS1, TxtS1, [x3, y3+ 2*markShift], [x4, y3+ 2*markShift]);//长度文字

plate={
 models: {
   drawAbnormalShapeB29: drawAbnormalShapeB29,
   }
 };
 markers={
   models: {
     drawAbnormalShapeB29: drawAbnormalShapeB29,
     drawAbnormalShapeB29MarkL: drawAbnormalShapeB29MarkL,
     drawAbnormalShapeB29MarkT: drawAbnormalShapeB29MarkT,
     drawAbnormalShapeB29MarkB:drawAbnormalShapeB29MarkB,
     drawAbnormalShapeB29MarkS1: drawAbnormalShapeB29MarkS1,
     drawAbnormalShapeB29MarkS2: drawAbnormalShapeB29MarkS2,
     drawAbnormalShapeB29MarkR: drawAbnormalShapeB29MarkR,
     }
   };
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default B29;